"use client";

import React from "react";

interface IListWithShowMoreProps {
  children: React.ReactNode;
  showMore?: boolean;
  showLess?: boolean;
  onShowMore?: () => void;
  onShowLess?: () => void;
  showMoreText?: string;
  showLessText?: string;
  containerClassName?: string;
  buttonContainerClassName?: string;
}

const ListWithShowMore: React.FC<IListWithShowMoreProps> = ({
  children,
  showMore = false,
  showLess = false,
  onShowMore,
  onShowLess,
  showMoreText = "Show More",
  showLessText = "Show Less",
  containerClassName = "",
  buttonContainerClassName = "",
}) => {
  return (
    <div className={containerClassName}>
      {children}
      
      {(showMore || showLess) && (
        <div className={`flex justify-center gap-4 mt-4 max-w-[850px] ${buttonContainerClassName}`}>
          {showMore && (
            <button
              type="button"
              onClick={onShowMore}
              className="h-[40px] p-[10px] md:h-[40px] md:min-w-[258px] md:px-[24px] md:py-[12px] rounded-[23px] text-[14px] font-medium text-link-primary border-link-primary border flex justify-center items-center cursor-pointer hover:bg-link-primary hover:text-white transition-colors max-sm:w-full"
            >
              {showMoreText.toLocaleUpperCase()}
            </button>
          )}
          {showLess && (
            <button
              type="button"
              onClick={onShowLess}
              className="h-[40px] p-[10px] md:h-[40px] md:min-w-[258px] md:px-[24px] md:py-[12px] rounded-[23px] text-[14px] font-medium text-link-primary border-link-primary border flex justify-center items-center cursor-pointer hover:bg-link-primary hover:text-white transition-colors max-sm:w-full"

            >
              {showLessText.toLocaleUpperCase()}1
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ListWithShowMore;
